import React, { useState, useEffect } from 'react'
import Radio from './radio'
import Input from './input'
import Spinner from './spinner'
import api from '../api/api'


const flightTypes =[
  {
    text:"Roundtrip",
    value: true
  },
  {
    text:"One way",
    value: false
  }
]

function renderText(element){
  return element.iata +" " +element.name
}

function FlightItinerary({index, itinerary, onChange, onDelete}) {  
  const [fromFlight, setFromFlight] = useState("")  
  const [toFlight, setToFlight] = useState("")
  const [via, setVia] = useState("")
  const fromValue =itinerary.fromValue;
  const toValue = itinerary.toValue;
  const viaValue = itinerary.viaValue;
  const passengers = itinerary.passengers;
  const flightType = itinerary.flightType;
  useEffect(()=>{
    if(itinerary.toValue){
      setToFlight(itinerary.toValue.iata + " "+itinerary.toValue.name)
    }
    if (itinerary.fromValue){
      setFromFlight(itinerary.fromValue.iata + " "+itinerary.fromValue.name)
    }
  },[itinerary])

  return (
    <div>
      
      {index!=0?(        
        <div className="section-title">
          Enter additional flight details 
          <span onClick={()=>onDelete(index)} className="selectable" aria-hidden="true">&times;</span>
        </div>
      ):null}
      <div className="form">
        <Input label="From" renderText={renderText} autocompleteFunc={api.getAutocompleteAirports}  value={fromFlight} onChange={setFromFlight} onSelect={(value)=> { onChange(index, {fromValue:value, toValue, passengers, flightType, viaValue} )} }/>
        <Input label="To" renderText={renderText} autocompleteFunc={api.getAutocompleteAirports}  value={toFlight} onChange={setToFlight} onSelect={(value)=> {onChange(index,{fromValue, toValue:value, passengers, flightType, viaValue}) }}/>
        <Input label="Via (optional)" renderText={renderText} autocompleteFunc={api.getAutocompleteAirports}  value={via} onChange={setVia} onSelect={(value)=> {onChange(index,{fromValue, toValue, passengers, flightType, viaValue:value}) }}/>
      </div>
      <Spinner min={1} max={5} label="Passengers" value={passengers} onChange={(i)=>onChange(index,{fromValue, toValue, passengers:i, flightType, viaValue}) }/>
      <Radio selected={flightType} options={flightTypes} onChange={(i)=>onChange(index,{fromValue, toValue, passengers, flightType:i, viaValue}) }/>
    </div>

  )


}


export default FlightItinerary